import { render, staticRenderFns } from "./likeContainer.vue?vue&type=template&id=2977af28&"
import script from "./likeContainer.vue?vue&type=script&lang=js&"
export * from "./likeContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports